/**
 * Public settings — قيم app_settings المتاحة للقراءة من المتصفّح بدون auth.
 * تُستخدم لإعدادات سلوك الواجهة (مثل: إخفاء COD على الهدايا).
 */
import { createServerFn } from "@tanstack/react-start";
import { readPublicBehaviorSettings } from "./publicSettings.server";

/**
 * يُرجع الإعدادات السلوكيّة العامّة المؤثّرة على الواجهة/السلّة.
 * لا تحتاج auth لأنّها قيم سلوك لا تكشف بيانات حسّاسة.
 */
export const getPublicBehaviorSettings = createServerFn({ method: "GET" }).handler(async () => {
  return readPublicBehaviorSettings();
});
